import fromEntries from 'object.fromentries';

Object.fromEntries = Object.fromEntries || fromEntries;
